import type { ReactNode } from "react";

interface DefaultColumnProps {
  data: ReactNode;
}

export const DefaultColumn = ({ data }: DefaultColumnProps) => {
  return <div className="two-lines-text text-nowrap">{data}</div>;
};
